const INITIAL_VALUES = {
  conceptName: '',
  conceptGroup: null,
};

export default INITIAL_VALUES;
